// import { call, fork, put, takeEvery } from "redux-saga/effects";
// import {
//   CreateNewUserRequest,
//   CreateNewUserSuccessAction,
// } from "../Reducers/AuthenticationReducer";
// import { push } from "react-router-redux";
// import { createNewUser } from "../api/firebaseApi";

// function* createNewAccount(payload) {
//   const { email, password } = payload;
//   console.log("hereerrrrrrrr in Saga");
//   try {
//     let loggedIn = false;
//     console.log("above");
//     const userDetails = yield call(createNewUser, { email, password });
//     console.log("below", userDetails);
//     if (loggedIn) {
//       yield put(CreateNewUserSuccessAction());
//       yield put(push("/"));
//     }
//   } catch (e) {
//     console.log(e);
//   }
// }

export default function* authenticationSaga() {
  // yield takeEvery(CreateNewUserRequest, createNewAccount);
}
